import gql from 'graphql-tag'

export default gql`
query activitiesPagination(
  $filter: FilterFindManyActivityInput
  $sort: SortFindManyActivityInput
  $page: Int
  $perPage: Int
) {
  activitiesPagination(filter: $filter, sort: $sort, page: $page, perPage: $perPage) {
    count
    items {
      _id
      eventId
      bib
      participantId
      status
      deviceId
      confidence
      createdAt
      participant {
        _id
        firstname
        lastname
      }
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
`
